<template>
  <el-row class="tac">
    <el-menu
      default-active="2"
      background-color="#545c64"
      text-color="#fff"
      active-text-color="#ffd04b"
      class="el-menu-vertical-demo el-menu" v-for="(item,index) in menuList" :key="index">
      <el-submenu index="index" >
        <template slot="title">
          <span class="menuCss1">{{item.name}}</span>
        </template>
        <el-menu-item-group v-for="(items,indexs) in item.child" :key="indexs">
          <el-menu-item :index="items.router" @click="addTab(items.name,items.router)">{{ items.name }}</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
    </el-menu>
  </el-row>
</template>
<script>

export default {
  props: {
    menuList:{
      //菜单内容
      type: Array,
      default: () => []
    },
    menuEventName:{
      //菜单点击事件名称
      type: String
    }
  },
  data () {
    return {

    }
  },
  methods:{
    addTab(targetName,tabIndex) {
      this.$emit(this.menuEventName,targetName,tabIndex)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .el-submenu__title{
    font-size: 28px !important;
  }
  .el-menu {
    border-right: none !important;
  }
  .el-tabs__content,.el-tab-pane{
    height: 100% !important;
  }
  .el-tabs__header{
    margin: 0 !important;
  }
  .menuCss1{
    font-size: 18px !important;
  }
  .tac{
    text-align: left !important;
    text-indent: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/MainMenu/index.vue